import React, { useState, useEffect } from "react";
import { Button } from "../components/ui/button";

const Success = () => {
  const [email, setEmail] = useState("");

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const raw = params.get("email") || "";
    try {
      const decoded = raw ? decodeURIComponent(raw) : "";
      setEmail(decoded);
    } catch (e) {
      setEmail(raw);
    }
  }, []);

  const handleContinue = () => {
    window.location.href = `https://app.butterscotchai.app${ email ? `?email=${encodeURIComponent(email)}` : `/`}`;
  };

  return (
    <div className="min-h-screen bg-[#0E0E0E] flex flex-col">
      <div className="flex-1 flex items-center justify-center px-4 pb-8">
        <div className="w-full max-w-md">
          <div className="text-center flex flex-col items-center justify-center min-h-[70vh] px-6">
            {/* Animated cards */}
            <div className="relative mb-8">
              <div className="flex gap-4 transform -rotate-12">
                <div className="w-24 h-32 rounded-2xl bg-gradient-to-br from-[#F1B428]/30 to-[#1A1A1A] border border-white/10 flex items-center justify-center text-3xl shadow-xl">
                  😊
                </div>
                <div className="w-24 h-32 rounded-2xl bg-gradient-to-br from-[#1A1A1A] to-[#2A2A2A] border border-[#F1B428]/30 flex items-center justify-center text-3xl shadow-xl transform rotate-6">
                  🔞
                </div>
                <div className="w-24 h-32 rounded-2xl bg-gradient-to-br from-[#2A2A2A] to-[#1A1A1A] border border-white/10 flex items-center justify-center text-3xl shadow-xl">
                  💧
                </div>
              </div>
            </div>

            <h1 className="text-white text-2xl md:text-3xl font-bold mb-4 mt-10">
              Your AI girlfriend
              <br />
              is ready 💗
            </h1>

            <p className="text-white/70 text-sm md:text-base mb-6 max-w-md">
              <br />
              Create your account at ButterscotchAI to meet her and start
              chatting instantly.
              <br />
              <br />
              Register at <i>app.butterscotchai.app</i> using the same email
              account to continue.
            </p>

            <p className="text-white/50 text-xs mb-8 max-w-sm">
              In case of any issues, please reach out to
              support@butterscotchai.app
            </p>

            <Button
              onClick={handleContinue}
              className={`w-full max-w-md font-bold text-lg py-6 rounded-full transition-all duration-300 ${"bg-[#F1B428] hover:bg-[#D9A022] text-black shadow-lg shadow-[#F1B428]/30 hover:scale-105"}`}
            >
              Continue
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Success;
